// Mobile filter trigger — the single "סינון" pill that sits beside the search
// input on ≤720px viewports and opens the page's FilterSheet. The badge shows
// how many non-search filters are active (search is excluded — it stays
// visible in the bar itself).
//
// `label` defaults to "סינון" for every existing consumer; SuppliersFilterBar
// is the one page that folds sort into the same sheet and passes "סינון ומיון"
// instead — a prop rather than a second component, since everything else
// about the trigger (icon, badge, sheet-opening) is identical either way.
export default function FilterButton({ activeCount = 0, onClick, expanded = false, label = 'סינון' }) {
  const isActive = activeCount > 0;
  return (
    <button
      type="button"
      className={`docs-filter-control filter-sheet-trigger${isActive ? ' is-active' : ''}`}
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={expanded}
    >
      {/* "Tune" icon — same glyph as the desktop MoreFilters trigger. */}
      <span className="more-filters-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round">
          <line x1="4" y1="6"  x2="20" y2="6" />
          <line x1="4" y1="12" x2="20" y2="12" />
          <line x1="4" y1="18" x2="20" y2="18" />
          <circle cx="9"  cy="6"  r="2.2" fill="currentColor" stroke="none" />
          <circle cx="15" cy="12" r="2.2" fill="currentColor" stroke="none" />
          <circle cx="9"  cy="18" r="2.2" fill="currentColor" stroke="none" />
        </svg>
      </span>
      <span>{label}</span>
      {isActive && <span className="multi-select-count">{activeCount}</span>}
    </button>
  );
}
